/* NOVAËLLE — interactions
   reveal-on-scroll · header shadow · accordion smooth · cart drawer slide
*/
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.novaelle-reveal').forEach(function (el) {
        el.classList.add('visible');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.novaelle-reveal').forEach(function (el) {
      io.observe(el);
    });
  }

  function initHeaderShadow() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    var apply = function () {
      if (window.scrollY > 12) header.classList.add('nv-scrolled');
      else header.classList.remove('nv-scrolled');
    };
    apply();
    window.addEventListener('scroll', apply, { passive: true });
  }

  function initLazyImages() {
    document.querySelectorAll('img:not([loading])').forEach(function (img) {
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
    });
  }

  function initNewsletterFeedback() {
    document.querySelectorAll('.nv-newsletter__form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('.nv-newsletter__btn');
        if (btn) btn.textContent = 'Merci';
      });
    });
  }

  onReady(function () {
    initReveal();
    initHeaderShadow();
    initLazyImages();
    initNewsletterFeedback();
  });
})();

// Protection des images Novaëlle

function isNovaelleImage(target) {
  return (
    target instanceof Element &&
    target.closest(
      'img, picture, .product__media, .product-media-container'
    )
  );
}

// Bloque le clic droit sur les images
document.addEventListener('contextmenu', function (event) {
  if (isNovaelleImage(event.target)) {
    event.preventDefault();
  }
});

// Bloque le glisser-déposer des images
document.addEventListener('dragstart', function (event) {
  if (isNovaelleImage(event.target)) {
    event.preventDefault();
  }
});

// Rend les images non déplaçables
function protectNovaelleImages() {
  document.querySelectorAll('img').forEach(function (img) {
    img.setAttribute('draggable', 'false');
  });
}

// Applique la protection
protectNovaelleImages();

document.addEventListener('DOMContentLoaded', function () {
  protectNovaelleImages();
});

// Protège aussi les images chargées dynamiquement par Shopify
const novaelleImageObserver = new MutationObserver(function () {
  protectNovaelleImages();
});

novaelleImageObserver.observe(document.body, {
  childList: true,
  subtree: true
});
